import { useMemo } from 'react';

import dayjs, { extend } from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { useGetWishlistDataFromCurrentGame } from '@pkg/hooks';

import { type Competition } from '@app/client/common/structs';

extend(utc);

export type GameStates = 'upcoming' | 'open' | 'playing' | 'closed' | 'ended' | 'loading';

export const useGetGameState = (currentGame?: Competition): { gameState: GameStates; isInfinite: boolean } => {
    const now = dayjs.utc();
    const { userWishlists } = useGetWishlistDataFromCurrentGame(currentGame);
    const { submission_ends_at, ends_at, submission_starts_at } = currentGame || {};
    const utcTime = (time?: string) => dayjs.utc(time || '');
    const endsAt = utcTime(ends_at);
    const startsAt = utcTime(submission_starts_at);
    const submissionEndsAt = utcTime(submission_ends_at);
    const isInfinite = currentGame?.multigame || false;

    const gameState = useMemo(() => {
        if (now.isAfter(endsAt)) {
            return 'ended';
        }
        if (now.isAfter(submissionEndsAt)) {
            return 'closed';
        }
        if (now.isBefore(submissionEndsAt)) {
            if (now.isBefore(startsAt)) {
                return 'upcoming';
            }
            return userWishlists ? 'playing' : 'open';
        }
        return 'loading';
    }, [endsAt, now, startsAt, submissionEndsAt, userWishlists]);

    return { gameState, isInfinite };
};
